import { Tax } from '../tax';

export class School {
    constructor(
        public id?: number,
        public name?: string,
        public sendReservationReminderEnable?: boolean,
        public sendPaymentReminderEnable?: boolean,
        public sendCardFinishedNotificationEnable?: boolean,
        public timezone?: string,
        public imageUrl?: string,
        public logoUrl?: string,
        public helpUrl?: string,
        public navbarColor?: string,
        public footerColor?: string,
        public backgroundColor?: string,
        public usePrioritiesEnable?: boolean,
        public onlinePaymentsModuleEnabled?: boolean,
        public recurrentReservationsModuleEnabled?: boolean,
        public acceptOnlinePayments?: boolean,
        public backofficeAccountId?: boolean,
        public onlineTransactionFee?: number,
        public onlineTransactionPercentageFee?: number,
        public administratorEmail?: string,
        public countryId?: number,
        public countryName?: string,
        public cityId?: number,
        public cityName?: string,
        public defaultTaxId?: number,
        public defaultTaxRate?: number,
        public euVATNumber?: string,
        public businessIdNumber?: string,
        public mainBusinessActivity?: string,
        public address?: string,
        public websiteUrl?: string,
        public supportUrl?: string,
        public facebookUrl?: string,
        public instagramUrl?: string,
        public youtubeUrl?: string,
        public tiktokUrl?: string,
        public supportPhone?: string,
        public supportEmail?: string,
        public subscriptionEndDate?: any,
        public maxDaysToShowInLessonsLists?: number,
        public invoiceDueDays?: number,
        public startingInvoiceNumber?: number,
        public invoiceGenerationByStudentEnabled?: boolean,
        public bookingWindowByStudentEnabled?: boolean,
        public defaultLessonMaxParticipants?: number,
        public defaultLessonReservationCancellationPolicy?: number,
        public defaultLessonReminderPolicy?: number
    ) {
        this.sendReservationReminderEnable = false;
        this.sendPaymentReminderEnable = false;
        this.sendCardFinishedNotificationEnable = false;
        this.usePrioritiesEnable = false;
        this.invoiceGenerationByStudentEnabled = false;
        this.bookingWindowByStudentEnabled = false;
        this.recurrentReservationsModuleEnabled = false;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/school/school.model.ts